import * as AuthActions from './../actions/auth.actions';
import { UserRoleType } from "./../../../models/userRoleTypes";
import { TokenService } from 'src/app/services/token/token.service';
import { selectRegistrationKiwiSaverFailText } from './../../registration-kiwisaver/selectors/registration-kiwisaver.selectors';
import { selectSignInAdvisorId } from './../selectors/auth.selectors';
import { AuthService } from 'src/app/services/http/auth.service';
import * as systemActions from './../../system/actions/system.actions';
import { map, switchMap, takeWhile, distinctUntilChanged } from 'rxjs/operators';
import { IAppState } from 'src/app/store/state/app.state';
import { Store, select } from '@ngrx/store';
import { Injectable } from "@angular/core";
import * as authSelectors from './../selectors/auth.selectors';
import { interval, merge, of, Observable, combineLatest } from 'rxjs';


@Injectable()
export class AuthFacade {

  constructor(private store: Store<IAppState>,
    private authService: AuthService,
    private tokenService: TokenService) {
  }

  public managerId$ = this.store.pipe(
    select(selectSignInAdvisorId)
  ).pipe(map((id: number) => {
    return id;
  }));


  public isUserInvestor$: Observable<boolean> = combineLatest([
    this.tokenService.claimsNotNull$,
    this.userLoggedIn$()
  ]).pipe(
    switchMap((v: [any, boolean]) => {
      const [claims, isLoggedIn] = v;
      if (!!claims && isLoggedIn) {
        const isAdministrator = this.tokenService.isAdministrator();
        const isAdvisor = this.authService.doesUserHaveRole(UserRoleType.Advisor);
        const isInvestor = (!isAdministrator && !isAdvisor) ? true : false;
        return of(isInvestor);
      } else {
        return of(false);
      }
    }));

  logout() {
    // TODO: simplify logic and create an effect that handles action and calls authservice.logout()
    this.store.dispatch(new AuthActions.Logout());
    this.authService.logout();
    this.store.dispatch(new systemActions.ClearSystemState());
  }

  logout$() {
    // TODO: simplify logic and create an effect that handles action and calls authservice.logout()
    this.store.dispatch(new AuthActions.Logout());
    this.store.dispatch(new systemActions.ClearSystemState());
    return this.authService.logout$().pipe(
      map((isCompleted: boolean) => {
        if (isCompleted) {
          if (!this.authService.isLoggedIn()) {
            return of(false);
          } else {
            const repeat = interval(200);
            // keep on repeating the interval, until isLoggedIn returns true. Return values until isLoggedin, plus take value when equation is met (hence the true as second param of takeWhile).
            return repeat.pipe(takeWhile(() => this.authService.isLoggedIn(), true), switchMap((timerValue) => {
              const isLoggedIn = this.authService.isLoggedIn();
              return of(isLoggedIn);
            }));
          }
        }
      }));
  }

  public userLoggedIn$(): Observable<boolean> {
    return this.authService.isLoggedIn$.pipe(distinctUntilChanged());
  }

  getAuthFailText() {
    const signInFailText$ = this.store.pipe(
      select(authSelectors.getSignInFailText)
    );
    const getKiwiSaverSignInFailText$ = this.store.pipe(
      select(selectRegistrationKiwiSaverFailText)
    );
    return merge(signInFailText$, getKiwiSaverSignInFailText$);
  }

  getHasFalseInception() {
    return this.store.pipe(select(authSelectors.getHasFalseInception));
  }

  public isAdministrator(): boolean {
    return this.tokenService.isAdministrator();
  }

  public isAdvisor(): boolean {
    return this.authService.doesUserHaveRole(UserRoleType.Advisor)
  }
  
  public doesUserHaveRole(userRoleType: UserRoleType): boolean {
    return this.authService.doesUserHaveRole(userRoleType);
  }

  public isAdministratorOrAdvisor() : boolean {
    return this.isAdministrator() || this.isAdvisor();
  }
  
}
